// extracted by mini-css-extract-plugin
export default {"burgerWrapper":"BurgerWrapper_burgerWrapper__8wpFg"};